import React from 'react';

export const gatherIcon = <img style={{width:50}} src={"../gatherTownIconMuted.png"}/>
